import {
  shape,
  string,
} from 'prop-types';

export default shape({
  correctInstance: string.isRequired,
  name: string.isRequired,
  qualifies: string.isRequired,
  youQualify: string.isRequired,
});